const FRENCH_TERRITORY_ISOS = [
  'BL',
  'GF',
  'GP',
  'MF',
  'MQ',
  'NC',
  'PF',
  'PM',
  'RE',
  'YT',
]

export const shippingZoneOf = country => {
  if (
    !country ||
    country.iso === 'FR' ||
    FRENCH_TERRITORY_ISOS.includes(country.iso)
  ) {
    return 'fr'
  }

  return country.is_from_eu ? 'eu' : 'int'
}

export const zonedShippingField = (item, field, zone) => {
  if (!item) return null
  if (zone === 'fr') return item[field]

  return item[`${field}_${zone}`] || item[field]
}
